import styled from "@mui/material/styles/styled";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";

export const ToggleButtonGroup = styled(MuiToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButton-root": {
    borderRadius: "4px !important",
    fontWeight: 400,
    height: "28px",
    minHeight: "28px",
    padding: "2px 8px",
    color: theme.palette.shades.neutral[600],
    backgroundColor: theme.palette.shades.neutral[50],
    border: "none",
    fontFamily: theme.typography.fontFamilySecondary,

    "&:not(:first-of-type)": {
      marginLeft: theme.spacing(1),
    },

    "&.Mui-selected": {
      color: "#FFF",
      backgroundColor: theme.palette.overlay.primary[24],
      "&:hover": {
        color: "#FFF",
        backgroundColor: theme.palette.overlay.primary[24],
      },
    },
  },
}));

export const SwitchLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryReg,
  color: theme.palette.shades.neutral[800],
  [theme.breakpoints.up("mobile")]: {
    whiteSpace: "nowrap",
  },
}));
